import React from 'react';
import PropTypes from 'prop-types';
import * as Headless from '@headlessui/react';
import clsx from 'clsx';

/**
 * A component that renders a legend element.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the legend.
 * @param {Object} [props.children] - Child elements to be rendered inside the legend.
 * @returns {JSX.Element} The rendered legend component.
 */
export function Legend({ className, ...props }) {
  return (
    <Headless.Legend
      data-slot="legend"
      {...props}
      className={clsx(
        className,
        'text-base/6 font-semibold text-zinc-950 data-[disabled]:opacity-50 sm:text-sm/6'
      )}
    />
  );
}

Legend.propTypes = {
  className: PropTypes.string,
};
